(function($) {
  // on page load.
  var $animation_elements = $("#MainContent .shopify-section");
  var $w = $(window);
  
  if ( window.location !== window.parent.location ) {
  // The page is in an iframe
    check_if_in_view(true);
    $("body").addClass('in-shopify-customizer');
} else {
  $(document).ready(function() {
    $(window).on("scroll load", function() {
      check_if_in_view();
    });
  });
}
  

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function check_if_in_view(forceShow = false) {
    var window_height = $w.height();
    var window_top_position = $w.scrollTop();
    var window_bottom_position = window_top_position + window_height;

    $.each($animation_elements, function() {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = element_top_position + element_height;

      //check to see if this current container is within viewport
      if (
        (element_bottom_position >= window_top_position &&
        element_top_position <= window_bottom_position) || forceShow
      ) {
        $element.addClass("inView");
      }
    });
  }
})(jQuery);
